/**
 * Lost Mary storefront customizations.
 * Loaded from snippets/lm-theme.liquid so Vision theme updates do not overwrite this file.
 *
 * Homepage SEO outline (matches the previous theme):
 *   H1 Lost Mary
 *   H6 trust badges
 *   H2 collection / section titles
 *   H3 product titles
 *   H5 blog post titles
 */
(function () {
  function copyAttributes(from, to) {
    Array.prototype.forEach.call(from.attributes, function (attr) {
      if (attr.name === 'class') return;
      to.setAttribute(attr.name, attr.value);
    });
  }

  function replaceTag(el, tagName, extraClass) {
    if (!el || el.tagName.toLowerCase() === tagName.toLowerCase()) {
      if (el && extraClass && el.className.indexOf(extraClass) === -1) {
        el.className = (el.className ? el.className + ' ' : '') + extraClass;
      }
      return el;
    }
    var replacement = document.createElement(tagName);
    replacement.className = el.className || '';
    if (extraClass && replacement.className.indexOf(extraClass) === -1) {
      replacement.className = (replacement.className ? replacement.className + ' ' : '') + extraClass;
    }
    copyAttributes(el, replacement);
    while (el.firstChild) replacement.appendChild(el.firstChild);
    el.parentNode.replaceChild(replacement, el);
    return replacement;
  }

  function demoteHeading(el) {
    replaceTag(el, 'div', el && el.tagName ? el.tagName.toLowerCase() : '');
  }

  function wrapProductTitle(el) {
    if (!el || el.closest('h3')) return;
    var heading = document.createElement('h3');
    heading.className = el.className;
    el.className = '';
    el.parentNode.insertBefore(heading, el);
    heading.appendChild(el);
  }

  function applySeoOutline() {
    document.querySelectorAll('.section-header--title').forEach(function (el) {
      replaceTag(el, 'h2', 'h3');
    });

    document.querySelectorAll('.product-card-title').forEach(function (el) {
      if (el.tagName === 'H3') return;
      if (el.tagName === 'A') {
        wrapProductTitle(el);
        return;
      }
      replaceTag(el, 'h3');
    });
  }

  function cleanHeadings() {
    document.querySelectorAll('h6').forEach(function (el) {
      if (!el.textContent.trim()) el.remove();
    });

    document.querySelectorAll(
      '.stamped-header h2, .stamped-header h3, .stamped-header-title, h3.stamped-title, .stamped-main-widget h2, .stamped-main-widget h3, .stamped-container h2, .stamped-container h3, .compare-drawer h5, .product-compare-modal__content-header h5'
    ).forEach(demoteHeading);

    document.querySelectorAll('h2, h3, h4, h5, h6').forEach(function (el) {
      var text = (el.textContent || '').trim().toLowerCase();
      if (
        text === 'deja que los clientes hablen por nosotros' ||
        text.indexOf('deja que los clientes hablen') === 0 ||
        text === 'let customers speak for us' ||
        text === 'comparar productos' ||
        text.indexOf('comparar productos') === 0
      ) {
        demoteHeading(el);
      }
    });
  }

  function run() {
    applySeoOutline();
    cleanHeadings();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  setTimeout(run, 1500);
  setTimeout(run, 4000);
})();

/**
 * Hide Smile.io Rewards launcher on mobile cart page and when the cart
 * drawer is open, so it does not cover checkout / view-cart buttons.
 */
(function () {
  var HIDE_CLASS = 'lm-hide-smile-launcher';
  var NODE_CLASS = 'lm-smile-launcher-hidden';
  var KNOWN_SELECTORS = [
    '#smile-ui-lite-container',
    '#smile-ui-container',
    '#smile-ui-lite-root',
    '#smile-ui-lite-launcher-frame-container',
    '[id^="smile-ui-lite-launcher"]',
    'iframe[name="smile-ui-lite-launcher-frame"]'
  ].join(',');

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function cartDrawerIsOpen() {
    var drawer = document.getElementById('Cart-Drawer');
    return !!(drawer && drawer.classList.contains('active'));
  }

  function shouldHide() {
    if (!document.body || !isMobile()) return false;
    if (document.body.classList.contains('template-cart')) return true;
    return cartDrawerIsOpen();
  }

  function markLaunchers(hide) {
    try {
      document.querySelectorAll(KNOWN_SELECTORS).forEach(function (el) {
        el.classList.toggle(NODE_CLASS, hide);
        el.setAttribute('aria-hidden', hide ? 'true' : 'false');
      });
    } catch (err) {}
  }

  function sync() {
    if (!document.body) return;
    var hide = shouldHide();
    document.body.classList.toggle(HIDE_CLASS, hide);
    markLaunchers(hide);
  }

  function start() {
    sync();

    document.addEventListener('cart-drawer:open', sync);
    document.addEventListener('panel:open', sync);
    document.addEventListener('panel:closed', sync);
    document.addEventListener('smile-ui-loaded', sync);
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);

    if (typeof MutationObserver !== 'function') return;

    var drawer = document.getElementById('Cart-Drawer');
    if (drawer) {
      new MutationObserver(sync).observe(drawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    var scheduled = false;
    new MutationObserver(function () {
      if (!shouldHide() || scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        sync();
      });
    }).observe(document.body, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/**
 * Skip cart terms checkbox: hide it via CSS and auto-accept so checkout
 * is not blocked by Vision's terms-checkbox validation.
 */
(function () {
  function acceptTerms() {
    document.querySelectorAll('terms-checkbox input[type="checkbox"]').forEach(function (el) {
      el.checked = true;
      el.removeAttribute('required');
      if (typeof el.setCustomValidity === 'function') el.setCustomValidity('');
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest || !e.target.closest('.checkout-button')) return;
      acceptTerms();
    },
    true
  );

  function start() {
    acceptTerms();
    document.addEventListener('cart-drawer:open', acceptTerms);
    document.addEventListener('cart:refresh', acceptTerms);
    document.addEventListener('line-item:change:end', acceptTerms);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/**
 * Collection/search "Comparar" toggle starts off. Vision's theme setting
 * show_compare_toggle_on defaults to on; Lost Mary wants it inactive until
 * the shopper turns it on.
 */
(function () {
  function turnOff() {
    var toggle = document.getElementById('compare_toggle');
    if (toggle) toggle.checked = false;
    if (!document.body) return;
    document.body.classList.remove('compare-true');
    document.body.classList.add('compare-false');
  }

  turnOff();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', turnOff);
  }
})();

/**
 * "Comparar productos" button does nothing when modal-dialog is already defined
 * while the page is parsed: its connectedCallback moves #CompareModal to <body>
 * before product-compare-panel is upgraded, so the panel keeps a null modal /
 * table reference and onStartClick throws. Re-attach the references.
 */
(function () {
  function findModal(panel) {
    var own = panel.querySelector('.product-compare-modal');
    if (own) return own;
    var modals = document.querySelectorAll('.product-compare-modal');
    return modals.length ? modals[modals.length - 1] : null;
  }

  function repair(panel) {
    if (panel.modal && document.contains(panel.modal) && typeof panel.modal.show === 'function') return;
    var modal = findModal(panel);
    if (!modal || typeof modal.show !== 'function') return;
    panel.modal = modal;
    panel.table = modal.querySelector('product-compare-table');
  }

  function repairAll() {
    document.querySelectorAll('product-compare-panel').forEach(repair);
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('.compare-start')) repairAll();
    },
    true
  );

  document.addEventListener('facets:updated', repairAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairAll);
  } else {
    repairAll();
  }
  window.addEventListener('load', repairAll);
})();

/**
 * Video section and collection-description videos: hide player chrome so clips
 * read as background visuals. Collection videos also autoplay muted and loop.
 */
(function () {
  function hidePlayer(video, backgroundMode) {
    if (!video) return;
    video.controls = false;
    video.removeAttribute('controls');
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.muted = true;
    video.setAttribute('disablepictureinpicture', '');
    video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
    video.disablePictureInPicture = true;
    if (backgroundMode) {
      video.autoplay = true;
      video.loop = true;
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      var playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt.catch(function () {});
      }
    }
  }

  /**
   * The RTE editor embeds Shopify-hosted clips as an iframe pointing straight at
   * the .mp4, which renders the browser's own player (with controls) inside a
   * cross-origin document we cannot style. Swap it for a real <video>.
   */
  function convertFileIframe(iframe) {
    var src = iframe.getAttribute('src') || iframe.getAttribute('data-src');
    if (!src || !/\.(mp4|webm|ogv|mov)(\?|#|$)/i.test(src)) return false;

    var video = document.createElement('video');
    video.src = src;
    video.className = iframe.className;
    if (iframe.parentNode) iframe.parentNode.replaceChild(video, iframe);
    hidePlayer(video, true);
    return true;
  }

  function hideEmbeddedPlayer(iframe) {
    if (!iframe || iframe.dataset.lmCollectionVideoReady === 'true') return;
    if (convertFileIframe(iframe)) return;
    var attribute = iframe.getAttribute('src') ? 'src' : 'data-src';
    var value = iframe.getAttribute(attribute);
    if (!value) return;

    try {
      var url = new URL(value, window.location.origin);
      var host = url.hostname.toLowerCase();
      if (host.indexOf('youtube.com') !== -1 || host.indexOf('youtu.be') !== -1) {
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('mute', '1');
        url.searchParams.set('loop', '1');
        url.searchParams.set('controls', '0');
        url.searchParams.set('playsinline', '1');
        url.searchParams.set('disablekb', '1');
        url.searchParams.set('fs', '0');
        var videoId = url.pathname.split('/').filter(Boolean).pop();
        if (videoId) url.searchParams.set('playlist', videoId);
      } else if (host.indexOf('vimeo.com') !== -1) {
        url.searchParams.set('background', '1');
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('muted', '1');
        url.searchParams.set('loop', '1');
        url.searchParams.set('controls', '0');
      } else {
        return;
      }
      iframe.setAttribute(attribute, url.toString());
      iframe.setAttribute('tabindex', '-1');
      iframe.dataset.lmCollectionVideoReady = 'true';
    } catch (error) {}
  }

  function run() {
    document.querySelectorAll('.video-section--container video').forEach(function (video) {
      hidePlayer(video, false);
    });
    document.querySelectorAll('.lm-collection-description video').forEach(function (video) {
      hidePlayer(video, true);
    });
    document.querySelectorAll('.lm-collection-description iframe').forEach(hideEmbeddedPlayer);
  }

  run();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  }
  document.addEventListener('facets:updated', run);
  window.addEventListener('load', run);
})();

/**
 * Hide "Comprar ahora" when the product is sold out and let Agotado fill the row.
 */
(function () {
  function isSoldOut(button) {
    if (!button) return false;
    if (button.disabled) return true;
    if (button.classList.contains('sold-out')) return true;
    return false;
  }

  function sync(holder) {
    var button = holder.querySelector('.single-add-to-cart-button');
    holder.classList.toggle('lm-sold-out', isSoldOut(button));
  }

  function syncAll() {
    document.querySelectorAll('.add_to_cart_holder').forEach(sync);
  }

  function start() {
    syncAll();
    document.querySelectorAll('.add_to_cart_holder .single-add-to-cart-button').forEach(function (button) {
      if (button.lmSoldOutObserved) return;
      button.lmSoldOutObserved = true;
      new MutationObserver(function () {
        var holder = button.closest('.add_to_cart_holder');
        if (holder) sync(holder);
      }).observe(button, { attributes: true, attributeFilter: ['disabled', 'class'] });
    });
  }

  start();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  }
  document.addEventListener('variant:change', start);
  document.addEventListener('quick-view:open', start);
})();

/**
 * Quick view: keep buy buttons after the price (and variants), before the
 * description, even if the JSON block order is changed or Vision is updated.
 */
(function () {
  function reorder() {
    var inner = document.querySelector('#Product-Drawer .product-information--inner');
    if (!inner) return;
    var title = inner.querySelector(':scope > .product-title-container');
    var buy = inner.querySelector(':scope > .product--product-form');
    if (!title || !buy) return;
    var variants = inner.querySelector(':scope > variant-selects');
    if (variants) {
      title.after(variants);
      variants.after(buy);
    } else {
      title.after(buy);
    }
  }

  document.addEventListener('quick-view:open', function () {
    reorder();
    requestAnimationFrame(reorder);
  });
})();

/**
 * Cart drawer Ofertas Flash: show 2 random products per browser session,
 * count down to midnight, and add the selected variant to cart.
 */
(function () {
  var STORAGE_KEY = 'lmFlashOfferIds';
  var LIMIT = 2;

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function formatTime(total) {
    var remaining = Math.max(0, total);
    var hours = Math.floor(remaining / 3600);
    var minutes = Math.floor((remaining % 3600) / 60);
    var seconds = remaining % 60;
    return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  function shuffle(list) {
    var copy = list.slice();
    for (var i = copy.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = copy[i];
      copy[i] = copy[j];
      copy[j] = tmp;
    }
    return copy;
  }

  function readStoredIds() {
    try {
      var stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(stored) ? stored.map(String) : [];
    } catch (error) {
      return [];
    }
  }

  function writeStoredIds(ids) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (error) {}
  }

  if (customElements.get('lm-flash-offers')) return;

  class LmFlashOffers extends HTMLElement {
    connectedCallback() {
      this.limit = parseInt(this.dataset.limit, 10) || LIMIT;
      this.remaining = parseInt(this.dataset.remaining, 10) || 0;
      this.timerEl = this.querySelector('.lm-flash-offers__time');
      this.pickProducts();
      this.tick = this.tick.bind(this);
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
      this.renderTime();
      this.timerId = window.setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.timerId) window.clearInterval(this.timerId);
    }

    pickProducts() {
      var items = Array.prototype.slice.call(this.querySelectorAll('[data-flash-product]'));
      if (!items.length) {
        this.hidden = true;
        return;
      }

      items.forEach(function (item) {
        item.hidden = true;
        item.classList.remove('is-visible');
      });

      var byId = {};
      items.forEach(function (item) {
        byId[String(item.dataset.productId)] = item;
      });

      var chosen = [];
      readStoredIds().forEach(function (id) {
        if (byId[id] && chosen.indexOf(byId[id]) === -1) chosen.push(byId[id]);
      });

      if (chosen.length < this.limit) {
        var pool = shuffle(
          items.filter(function (item) {
            return chosen.indexOf(item) === -1;
          })
        );
        chosen = chosen.concat(pool).slice(0, this.limit);
      }

      chosen.slice(0, this.limit).forEach(function (item) {
        item.hidden = false;
        item.classList.add('is-visible');
      });

      writeStoredIds(
        chosen.slice(0, this.limit).map(function (item) {
          return String(item.dataset.productId);
        })
      );

      this.hidden = chosen.length === 0;
    }

    tick() {
      this.remaining -= 1;
      if (this.remaining < 0) this.remaining = 86400 - 1;
      this.renderTime();
    }

    renderTime() {
      if (this.timerEl) this.timerEl.textContent = formatTime(this.remaining);
    }

    onClick(event) {
      var button = event.target.closest('.lm-flash-offers__add');
      if (!button || !this.contains(button) || button.classList.contains('loading')) return;
      event.preventDefault();
      this.addToCart(button);
    }

    getSectionsToRender() {
      return [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    addToCart(button) {
      var variantId = button.getAttribute('data-variant-id');
      if (!variantId || typeof theme === 'undefined' || !theme.routes) return;

      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');
      button.disabled = true;

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map(function (section) {
        return section.section;
      }));
      formData.append('sections_url', window.location.pathname);

      var config = typeof FETCH_CONFIG !== 'undefined'
        ? Object.assign({}, FETCH_CONFIG, { body: formData })
        : {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/javascript'
            },
            body: formData
          };

      fetch(theme.routes.cart_add_url, config)
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) return;

          var row = button.closest('[data-flash-product]');
          var addedId = row && row.getAttribute('data-product-id');
          if (addedId) {
            writeStoredIds(
              readStoredIds().filter(function (id) {
                return id !== String(addedId);
              })
            );
          }

          this.getSectionsToRender().forEach(function (section) {
            var el = document.getElementById(section.id);
            if (!el) return;
            var elementToReplace = el.querySelector(section.selector) || el;
            if (response.sections && response.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                response.sections[section.section],
                section.selector
              );
            }
          }.bind(this));

          if (typeof Cart !== 'undefined') {
            new Cart().renderContents(response);
          }

          if (typeof dispatchCustomEvent === 'function') {
            dispatchCustomEvent('cart:item-added', {
              product: response.hasOwnProperty('items') ? response.items[0] : response
            });
          }

          var cartDrawer = document.getElementById('Cart-Drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
        }.bind(this))
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
          button.disabled = false;
        });
    }
  }

  customElements.define('lm-flash-offers', LmFlashOffers);
})();

/**
 * SELLY widgets: Spanish labels when the app still ships English copy.
 * Visual restyle lives in lm-selly.css. Prefer translating in Selly admin too.
 */
(function () {
  var LABELS = {
    'your discount:': 'Tu descuento:',
    'your discount': 'Tu descuento',
    'free gift': 'Regalo',
    'checkout': 'Tramitar pedido',
    'select gift': 'Elegir regalo',
    'no thanks': 'No, gracias',
    'product details': 'Ver producto',
    'add to cart': 'Añadir al carrito',
    'add': 'Añadir',
    'explore': 'Explorar'
  };
  var pending = false;

  function isSpanish() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return lang.indexOf('es') === 0;
  }

  function applyLabel(el) {
    if (!el) return;
    if (el.querySelector && el.querySelector('.tdf_gift_title, a, .tdf_discount_text, button')) return;
    var raw = (el.textContent || '').replace(/\s+/g, ' ').trim();
    var next = LABELS[raw.toLowerCase()];
    if (next && raw !== next) el.textContent = next;
  }

  function localizeAll() {
    pending = false;
    document.querySelectorAll(
      '.tdf_container .tdf_discount_title, .tdf_container .tdf_discount_tag, .tdf_container .tdf_cta_btn, .tdf_container .tdf_normal_btn, .tdf_container .tdf_qv_a, .tdf_container .tdf_bar_btn button, .tdf_rec .tdf_cta_btn, .tdf_rec .tdf_normal_btn'
    ).forEach(applyLabel);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(localizeAll);
    } else {
      setTimeout(localizeAll, 16);
    }
  }

  function start() {
    if (!isSpanish()) return;
    localizeAll();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
